import {
  ApiError,
  Box,
  CenteredLoader,
  Flex,
  Text,
  TriangleDownIcon,
  TriangleUpIcon,
} from "@shared/primitive-components"
import formatMoney from "@shared/utils/formatters/formatMoney"
import { Stat, SummaryCardMainText } from ".."
import { LOSS_RATIO_TARGET } from "../../const"
import { rebatesStyles as styles } from "../../styles"
import { useRebateSummary } from "../../../api/rebates/useGetRebateSummary"

export const REBATES_SUMMARY_DTI = {
  STAT: `rebates_summary_stat`,
  CHANGE: `rebates_summary_change`,
}

const RebateChartSummary = () => {
  const { apiErrored: errRebates, data: summary, loading: rebatesLoading } = useRebateSummary()
  const change = summary?.changeInRebate ? Math.abs(summary.changeInRebate) : undefined
  const RebateChangeIcon = !rebatesLoading && (summary?.changeInRebate || 0) > 0 ? TriangleUpIcon : TriangleDownIcon
  // Disable Rebate amount if loss ratio value is not lower than threshold
  const disabledStat = !((summary?.lossRatio ?? 0) < LOSS_RATIO_TARGET)
  if (errRebates) return <ApiError />

  return (
    <Flex flexDirection="column" justifyContent="space-between" height="100%">
      <SummaryCardMainText
        description={
          rebatesLoading
            ? ``
            : `Here is the rebate you've accumulated so far. Remember that your total rebate can go up or down throughout the policy period.`
        }
        main="Accumulated rebate"
        target=""
      />
      <Flex alignItems="center">
        {rebatesLoading ? (
          <>
            <CenteredLoader top="-10.3rem" />
            <div />
          </>
        ) : (
          <>
            <Box as="div">
              <Stat
                stat={formatMoney(summary?.accumulatedRebate || 0)}
                dataTestIds={{ stat: REBATES_SUMMARY_DTI.STAT }}
                disabled={disabledStat}
              />
            </Box>
            <Box css={styles.marginLeft(6)}>
              {!!summary?.changeInRebate && change && (
                <>
                  <Text
                    css={styles.rebateStatChangeFigure(summary?.changeInRebate >= 0)}
                    data-testid={REBATES_SUMMARY_DTI.CHANGE}
                  >
                    <RebateChangeIcon />
                    {formatMoney(change)}
                  </Text>
                  <Text>Since last month</Text>
                </>
              )}
            </Box>

            {!!summary?.accumulatedRebate || (
              <Text css={styles.textDetail}>
                Your rebate will be paid after your policy period ends. If you don&apos;t choose to renew with Flock you
                will not be eligible for a rebate payment.
              </Text>
            )}
          </>
        )}
      </Flex>
    </Flex>
  )
}

export const RebateChartSummaryComponent = <RebateChartSummary />
